import React from 'react';
import {Col, Panel, Row} from 'react-bootstrap';
import PropTypes from 'prop-types';
import ErrorComponent from './ErrorComponent';


class EditPage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isCreating: props.isCreating,
    };
  }

  getTitle = () => {
    if (this.props.title) return this.props.title;

    if (this.props.isCreating) {
      return 'Create';
    } else if (this.props.isInviting) {
      return 'Invite';
    } else {
      return 'Edit';
    }
  };

  render() {
    const error = this.props.error ? <ErrorComponent error={this.props.error}/> : '';

    return (
      <div>
        <Row>
          <Col xs={12} md={8} mdOffset={2}>
            {error}
            <Panel>
              <Panel.Heading>
                <Panel.Title componentClass="h3">{ this.getTitle() } {this.props.editType}</Panel.Title>
              </Panel.Heading>
              <Panel.Body>
                {React.Children.only(this.props.children)}
              </Panel.Body>
            </Panel>
          </Col>
        </Row>
      </div>
    );
  }
}

EditPage.propTypes = {
  editType: PropTypes.string,
  error: PropTypes.array,
  isCreating: PropTypes.bool,
  isInviting: PropTypes.bool,
  title: PropTypes.string
};

export default EditPage;



// WEBPACK FOOTER //
// ./src/components/EditPage.js